import React from 'react';
import { useTranslation } from 'react-i18next';

import { drugsModel } from '../../../constants';
import { LabeledSelect } from '../Input/LabeledSelect';

const ActivePassiveSelect = ({ withAll = true, allowClear = true, disabled, asBoolean = false, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        ...((withAll && !asBoolean) ? [ { value: drugsModel.STATUS_VALUE.ALL, text: t('fields.status.all') } ] : []),
        { value: asBoolean ? true : drugsModel.STATUS_VALUE.ACTIVE, text: t('fields.status.active') },
        { value: asBoolean ? false : drugsModel.STATUS_VALUE.PASSIVE, text: t('fields.status.passive') }
      ] }
    />
  );
};
export default ActivePassiveSelect;
